import { State } from './types';
import { Actions, RESET_CART, SET_CART } from './actions';

export const NAMESPACE = 'cart';

const initialState: State = {
    cart: null
};

export const reducer = (state: State = initialState, action: Actions) => {
    switch (action.type) {
        case RESET_CART:
            return { ...state, cart: null };
        case SET_CART:
            return { ...state, cart: action.payload.cart }
        default:
            return state;
    }
};

export default reducer;
